import { createSlice } from "@reduxjs/toolkit";
import { FoldersSliceState } from "./folders-interface";
import { fetchFoldersByApplication } from "./folders-async-calls";

const initialState: FoldersSliceState = {
  folders: [],
  isFetching: false,
};

const folderSlice = createSlice({
  name: "folders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFoldersByApplication.pending, (state) => {
        state.folders = [];
        state.isFetching = true;
      })
      .addCase(fetchFoldersByApplication.fulfilled, (state, action) => {
        state.folders = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchFoldersByApplication.rejected, (state) => {
        state.folders = [];
        state.isFetching = false;
      });
  },
});

export const {} = folderSlice.actions;

export default folderSlice.reducer;
